import { useCallback, useEffect, useState } from "react";
import { DEFAULT_SITE_CONTENT } from "../../content/defaultSiteContent";

export function useAdminSiteContent({ adminApi, verified, adminToken }) {
  const [siteConfig, setSiteConfig] = useState(DEFAULT_SITE_CONTENT);
  const [siteLoading, setSiteLoading] = useState(false);
  const [siteSaving, setSiteSaving] = useState(false);
  const [siteDirty, setSiteDirty] = useState(false);
  const [siteEditorTab, setSiteEditorTab] = useState("home");

  const fetchSiteConfig = useCallback(async (token = adminToken) => {
    if (!token) return;
    setSiteLoading(true);
    try {
      const response = await adminApi.post("/site/get", { adminToken: token });
      setSiteConfig(response.data || DEFAULT_SITE_CONTENT);
      setSiteDirty(false);
    } catch (err) {
      console.error("Ошибка загрузки контента сайта:", err);
    } finally {
      setSiteLoading(false);
    }
  }, [adminApi, adminToken]);

  async function saveSiteConfig() {
    if (!adminToken || !siteConfig) return;
    setSiteSaving(true);
    try {
      const response = await adminApi.post("/site/save", {
        adminToken,
        config: siteConfig
      });
      if (response.data?.config) {
        setSiteConfig(response.data.config);
      }
      setSiteDirty(false);
    } catch (err) {
      console.error("Ошибка сохранения контента сайта:", err);
      alert("Не удалось сохранить контент сайта");
    } finally {
      setSiteSaving(false);
    }
  }

  function updateSiteConfig(updater) {
    setSiteConfig((prev) => {
      const next = typeof updater === "function" ? updater(prev) : updater;
      return next || prev;
    });
    setSiteDirty(true);
  }

  function resetSiteConfig() {
    fetchSiteConfig();
  }

  useEffect(() => {
    if (verified && adminToken) {
      fetchSiteConfig(adminToken);
    }
  }, [verified, adminToken, fetchSiteConfig]);

  return {
    siteConfig,
    siteLoading,
    siteSaving,
    siteDirty,
    siteEditorTab,
    setSiteEditorTab,
    fetchSiteConfig,
    saveSiteConfig,
    updateSiteConfig,
    resetSiteConfig
  };
}
